import styled from '@emotion/styled';
import { Loader } from '@hotjar/hotsauce';
import { useNavigation } from '@hotjar/navigation';

const S = {
  ContentContainer: styled.div<{ topNavHeight: number }>`
    height: calc(100vh - ${({ topNavHeight }) => topNavHeight}px);
    display: flex;
    justify-content: center;
    align-items: center;
  `,
};

export const PageLoader = (): JSX.Element => {
  const { topBarHeight: topNavHeight } = useNavigation();

  return (
    <S.ContentContainer topNavHeight={topNavHeight}>
      <Loader size="xl" />
    </S.ContentContainer>
  );
};
